import { render, staticRenderFns } from "./NsProductPrice.vue?vue&type=template&id=0e11ca1a&"
import script from "./NsProductPrice.vue?vue&type=script&lang=js&"
export * from "./NsProductPrice.vue?vue&type=script&lang=js&"
import style1 from "./NsProductPrice.vue?vue&type=style&index=1&lang=scss&module=%24x&"




function injectStyles (context) {
  
  this["$x"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports